<template>
  <div id="main" >
    <mt-radio
    title="选择科室"
    v-model="value"
    :options="list">
    </mt-radio>

    <ul  v-show="value!=false">

    <mt-radio
    title="选择排队日期"
    v-model="selecteddate"
    :options="receptdatelist" @change="checkeds">
    </mt-radio>

    </ul>

    <ul v-show="selecteddate!=false">
      <mt-radio
        title="选择上下午"
        v-model="selectedampm"
        :options="ampmlist" v-on:click="selectchange()">
      </mt-radio>


    </ul>

    <mt-button type="primary" @click="submitqueuinfo()" size="large" v-show="allowsubmit">确定预约</mt-button>


    <!-- <mt-header title="选择科室">
      <router-link to="/" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
    </mt-header>

    <ul v-for="item in list" :key="item.bianhao">
        <mt-cell :title="item.name" is-link :to="'/submitappointment?bianhao='+item.bianhao"></mt-cell>
    </ul> -->

  </div>  
</template>

<script>
import Axios from 'axios'
import qs from 'qs';

export default {
  name: 'main',
  data () {
    return {
      msg: '这里是预约管理主页面',   
      currentdate:'',
      vipname:'',
      wxopenid:'',
      wxbaseinfo:{
        openid:'',
        name:'',
        sex:'',
        idnumber:'',
        tel:'',
        status:''
      },
      value:'',
      list:[],
      selecteddate:'',
      receptdatelist:[],
      selectedampm:'',
      ampmlist:[],
      amallow:false,
      pmallow:false,
      allowsubmit:false
    }
  },
  created(){       
    // 1、从缓存读取openid    
    var temopenid="oym4F6GbgItOvrqilutyj4W-y5Rw";//localStorage.getItem('wxopenid');
    if(temopenid && temopenid!='undefined'){
        // 缓存存在
        this.wxbaseinfo.openid=temopenid;
        // 验证基本信息（是否有姓名）,无信息则完善基本信息
        this.checkInfo();   
    }
    else{
        // 缓存不存在，则跳转到授权页
        this.$router.push({path:'/authtest'});
    } 
  },
  methods:{
    // 验证用户信息
    checkInfo(){
      // 验证个人信息
      var api='http://localhost:6334/api/checkinfo';
      Axios.post(api,qs.stringify({
        'openid':this.wxbaseinfo.openid
        }),{emulateJSON: true},{
          headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}
        }).then(response=>{
              if(response.data.result=='false'){
                  // 出错了，则跳到出错处理页面
                  this.$router.push({path:'/err'});
              }
              else{
                if(response.data.data.name==null || response.data.data.name==''){
                    // 没有姓名信息跳转到完善基本信息
                    // this.$router.push({path:'/baseinfo'})
                    this.$router.push({name:'baseinfo',params:{'openid':response.data.data.openid}});
                }
                else{                    
                  // 信息完事，则正常显示 
                  this.vipname=response.data.data.name;
                  if(this.vipname){
                      this.wxbaseinfo.name=response.data.data.name;
                      this.wxbaseinfo.sex=response.data.data.sex;
                      this.wxbaseinfo.tel=response.data.data.tel;
                      this.wxbaseinfo.idnumber=response.data.data.idnumber;
                        // 加载科室列表
                        this.loadDepartmentlist();
                        // 加载有效接诊日期列表
                        this.loadReceptDatelist();
                    }
                }
              }
      }),function(err){
          alert('appointment验证用户失败：' + err);
      }
    },
    // 加载科室列表
    loadDepartmentlist(){
        var api='http://localhost:6334/api/departmentlist';
        Axios.get(api).then((response)=>{            
            if(response.data.result=='false'){
                // 出错了，则跳到出错处理页面
                // this.$router.push({path:'/err'});
            }
            else{
                console.log(response);
                for(var i=0;i<response.data.data.length;i++)
                {
                    let temitem=response.data.data[i];
                    console.log('打印出来的数据项:' + temitem);
                    this.list.push(temitem);
                    console.log(temitem.name);
                }
            }
        }).catch((err)=>{
            alert('appointment验证用户失败：' + err);
        })
    },
    // 加载有效接诊时间列表
    loadReceptDatelist(){
        var api='http://localhost:6334/api/receptdate';
        Axios.get(api).then((response)=>{            
            if(response.data.result=='false'){
                // 出错了，则跳到出错处理页面
                // this.$router.push({path:'/err'});
            }
            else{
                console.log(response);
                for(var i=0;i<response.data.data.length;i++)
                {
                    let temitem=response.data.data[i];
                    console.log('打印出来的数据项:' + temitem);
                    this.receptdatelist.push(temitem);
                    console.log(temitem.name);
                }
            }
        }).catch((err)=>{
            alert('appointment验证用户失败：' + err);
        })
    },
    // 加载系统提示信息
    loadSystemTipInfo(){
        var api='http://localhost:6334/api/systeminfo?cla=servicetip';
        Axios.get(api).then((response)=>{            
            if(response.data.result=='false'){
                // 出错了，则跳到出错处理页面
                // this.$router.push({path:'/err'});
            }
            else{
                console.log(response);
                // 解码用 
                this.introduction=decodeURIComponent(response.data.data);
            }
        }).catch((err)=>{
            alert('appointment获取系统信息失败：' + err);
        })
    },
    selectchange(){
      alert('选择的科室：' + this.selecteddate);
    },
    checkeds(){
      var api='http://localhost:6334/api/receptampm?date=' + this.selecteddate;
        Axios.get(api).then((response)=>{            
            if(response.data.result=='false'){
                // 出错了，则跳到出错处理页面
                // this.$router.push({path:'/err'});
            }
            else{
                console.log(response);
                this.selectedampm='am';
                this.ampmlist=[];
                // 获取当前时间
                this.getCurrentTime();
                
                //alert('currentdate:' + this.currentdate.substring(0,10));


                for(var i=0;i<response.data.data.length;i++)
                {
                    let temitem=response.data.data[i];
                    // console.log('打印出来的数据项:' + temitem);
                    if(temitem.ampm=='am'){
                      // 上午
                      if(temitem.remain!=0){    
                        // 是否为当天的                        
                        if(this.currentdate.substring(0,10)==this.selecteddate.substring(0,10)){
                          // 说明选择的是当天的
                          // 当前时间是否已过上午的预约时间
                          let date1=new Date(this.selecteddate + ' 11:30:00');
                          let date2=new Date(this.getCurrentTime());
                          if(date1.gettime>date2.gettime){
                            this.ampmlist.push({
                              label:'上午      已约：' + temitem.appointed + '，余量：' + temitem.remain,
                              value: 'am'
                            })
                            // 上午可用                        
                            this.amallow=true;
                          }
                          else{
                            this.ampmlist.push({
                              label:'上午      已约：' + temitem.appointed + '，余量：' + temitem.remain,
                              value: 'am',
                              disabled:true
                            })
                            // 上午不可用                        
                            this.amallow=false;
                          }
                        }
                        else{
                          // 不是当天则直接可用
                          this.ampmlist.push({
                            label:'上午      已约：' + temitem.appointed + '，余量：' + temitem.remain,
                            value: 'am'
                          })
                          // 上午禁用
                          this.amallow=true;
                        }                        
                      }
                      else{
                        this.ampmlist.push({
                          label:'上午      已约：' + temitem.appointed + '，余量：' + temitem.remain,
                          value: 'am',
                          disabled:true
                        })
                        // 上午禁用
                        this.amallow=false;
                      }
                    }
                    else{
                      // 下午
                      if(temitem.remain!=0){
                        // 是否为当天的 
                        if(this.currentdate.substring(0,10)==this.selecteddate.substring(0,10)){
                          // 是当天，则要判断当前时间
                          let date3=new Date(this.selecteddate + ' 17:00:00');
                          let date4=new Date(this.getCurrentTime());
                          if(date3.gettime>date4.gettime){
                            this.ampmlist.push({
                              label:'下午      已约：' + temitem.appointed + '，余量：' + temitem.remain,
                              value: 'pm'
                            })
                            // 下午可用                        
                            this.amallow=true;
                          }
                          else{
                            this.ampmlist.push({
                              label:'下午      已约：' + temitem.appointed + '，余量：' + temitem.remain,
                              value: 'pm',
                              disabled:true
                            })
                            // 下午不可用                        
                            this.amallow=false;
                          }

                        }
                        else{
                          // 不是当天，则直接可用
                          this.ampmlist.push({
                            label:'下午      已约：' + temitem.appointed + '，余量：' + temitem.remain,
                            value: 'pm'
                          })
                          // 下午可用                        
                          this.amallow=true;
                        }                        
                      }
                      else{
                        this.ampmlist.push({
                          label:'下午      已约：' + temitem.appointed + '，余量：' + temitem.remain,
                          value: 'pm',
                          disabled:true
                        })
                        // 下午禁用
                        this.pmallow=false;
                      }
                    }
                }
                // 是否允许提交
                if(this.amallow || this.pmallow){
                  this.allowsubmit=true
                }
                else{
                  this.allowsubmit=false
                }
            }
        }).catch((err)=>{
            alert('checkeds获取上下午预约信息失败' + err);
        })
    },
    submitqueuinfo(){
      // 提交排队，则跳转到排队信息显示界面
      this.$router.push({name:'submitappointment',params:{'bianhao':this.value,'date':this.selecteddate,'ampm':this.selectedampm}});
    },
    getCurrentTime() {
      //获取当前时间并打印
      var _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth()+1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
      this.currentdate=yy+'-'+mm+'-'+dd+' '+hh+':'+mf+':'+ss;
      _this.gettime = yy+'-'+mm+'-'+dd+' '+hh+':'+mf+':'+ss;
    }
  }
}
</script>

<style>
#main,/*设置占满*/
html,
body {
  background-color: #f4f4f4;
  width: 100%;
  height: 100%;
  margin: 0;
}
ul{
    /* background-color: blue;
    text-align: left; */
    margin: 5px;
    padding:0px;
}
</style>


// WEBPACK FOOTER //
// src/components/appointmentonlinetest.vue